import Type from "@/model/types/Type";


const type = {
    CREATED: 1,
    READ: 2,
    UPDATED: 3,
    DELETED: 4,
    INITIATED: 5,
    FINISHED: 6,
    CHANGE_STATUS: 7,
}

const list = [
    {
        value: type.CREATED,
        text: "Incluir",
    },
    {
        value: type.READ,
        text: "Ler",

    },
    {
        value: type.UPDATED,
        text: "Atualizar",

    },
    {
        value: type.DELETED,
        text: "Excluir",

    },
    {
        value: type.INITIATED,
        text: "Iniciar etapa",

    },
    {
        value: type.FINISHED,
        text: "Finalizar etapa",
    },
    {
        value: type.CHANGE_STATUS,
        text: "Mudança de Status",

    }

]

const typeList = {
    FORM: "form",
    STEP: "step",
    STATUS: "status",
}

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const listByType = function (itemType) {

    if (itemType === typeList.FORM) {
        return list.filter(a => a.value === type.CREATED || a.value === type.READ || a.value === type.UPDATED || a.value === type.DELETED)
    } else if (itemType === typeList.STEP) {
        return list.filter(a => a.value === type.INITIATED || a.value === type.CHANGE_STATUS)
    } else if (itemType === typeList.STATUS) {
        return list.filter(a => a.value === type.CHANGE_STATUS)
    }
}

export default {
    type,
    list,
    contains,
    typeList,
    listByType,
}